import type React from 'react';

import AddVerktoyElement from '@components/verktoy-liste/add-verktoy-element';
import DeleteVerktoyElement from '@components/verktoy-liste/delete-verktoy-element';
import { erVerktoyTilgjengelig } from '@utils/utils';

import type { Verktoy } from '@src/types/minhelseentities';
import type { HNVerktoyFrontend } from '@src/types/Resources';

import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ArrowRight from '@helsenorge/designsystem-react/components/Icons/ArrowRight';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

import styles from '../../styles/verktoy-buttons.module.scss';
import { getVerktoyInfoStates } from '../../utils/launchUtil';
import LaunchUserInfo from '../info/launch-userinfo';

interface VerktoyButtonsProps {
  verktoy: Verktoy;
  erLaeringsaktivitet: boolean;
  resources: HNVerktoyFrontend | undefined;
  moreInfoButtonClicked: () => void;
}

const VerktoyButtons: React.FC<VerktoyButtonsProps> = ({ verktoy, erLaeringsaktivitet, resources, moreInfoButtonClicked }) => {
  const erTilgjengelig = erVerktoyTilgjengelig(verktoy);
  const isAuthorizedUser = isAuthorized();
  const infoStates = getVerktoyInfoStates({ verktoy, erTilgjengelig, erLaeringsaktivitet, isAuthorizedUser });

  return (
    <div className={styles.buttonsWrapper}>
      <div className={styles.buttonsRow}>
        <div className={styles.buttonsLeft}>
          <DeleteVerktoyElement verktoy={verktoy} erLaeringsaktivitet={erLaeringsaktivitet} className={styles.deleteButton} />
          <AddVerktoyElement verktoy={verktoy} erLaeringsaktivitet={erLaeringsaktivitet} />
        </div>
        <div className={styles.moreInfoButton}>
          <Button aria-roledescription={resources?.roleDescription_link} variant="borderless" onClick={moreInfoButtonClicked}>
            {resources?.toDetailsPageButton}
            <Icon svgIcon={ArrowRight} />
          </Button>
        </div>
      </div>
      {infoStates.length > 0 && (
        <div className={styles.infoBelow}>
          <LaunchUserInfo erLaeringsaktivitet={erLaeringsaktivitet} verktoy={verktoy} />
        </div>
      )}
    </div>
  );
};

export default VerktoyButtons;
